module.exports = __webpack_public_path__ + "static/media/moderna_logo.cd7fefc6.png";